// useTableColumnsMaterialesSinMovimiento.tsx

import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { MaterialesSinMovimiento } from "../types/equipos-sin-movimiento.interface";

export function useTableColumnsMaterialesSinMovimiento() {

  const columns = useMemo<MRT_ColumnDef<MaterialesSinMovimiento>[]>(
    () => [
      {
        accessorKey: "fecha_registra",
        header: "Fecha Registro",
      },
      {
        accessorKey: "meses_sin_movimiento",
        header: "Meses Sin Movimiento",
      },
      {
        accessorKey: "id_material",
        header: "ID Material",
      },
      {
        accessorKey: "codigo_producto",
        header: "Codigo Producto",
      },
      {
        accessorKey: "tie_nombre",
        header: "Material",
      },
      {
        accessorKey: "cantidad",
        header: "Cantidad",
      },
      {
        accessorKey: "tipo_transaccion",
        header: "Tipo Transaccion",
      },
      {
        accessorKey: "bodega_desde",
        header: "Bodega Desde",
      },
      {
        accessorKey: "bodega_hasta",
        header: "Bodega Hasta",
      },
      {
        accessorKey: "detalle_transferencia",
        header: "Detalle Transferencia",
      },
    ],
    []
  );

  return {
    columns
  };
}